import { render, staticRenderFns } from "./DragAndDropComparison.vue?vue&type=template&id=5d7a238a&scoped=true&"
import script from "./DragAndDropComparison.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropComparison.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropComparison.vue?vue&type=style&index=0&id=5d7a238a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a238a",
  null
  
)

export default component.exports